import React from "react";

interface FileDropperProps extends React.HTMLAttributes<HTMLDivElement> {
  onFilesDropped: (files: FileList) => void;
  multiple?: boolean;
}

export const FileDropper = React.forwardRef<HTMLDivElement, FileDropperProps>(
  ({ onFilesDropped, multiple, ...props }, ref) => {
    const handleDrop = React.useCallback(
      (e: React.DragEvent<Element>) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        if (!files.length) {
          return;
        }
        if (files.length > 1 && !multiple) {
          // Kick back an error perhaps, but for now an alert is fine
          alert("You may only upload one file");
          return;
        }
        onFilesDropped(e.dataTransfer.files);
      },
      [ onFilesDropped, multiple ]
    );

    const handleDrag = React.useCallback(
      (e: React.DragEvent<HTMLDivElement>) => e.preventDefault(),
      []
    );

    return (
      <div ref={ref} {...props} onDragOver={handleDrag} onDrop={handleDrop} />
    )
  }
);
FileDropper.displayName = "FileDropper";
